import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  configPath = urlServer.concat("/v1/settings");
  reviveMailPath = urlServer.concat("/v1/settings/authorize");
  deadlineSettingPath = urlServer.concat("/v1/settings/visitDeadline");
  fieldSettingPath = urlServer.concat("/v1/settings/fieldVisibility");
  copyRelanceSubject:Subject<any>;
  deadlineSubject:Subject<any>;
  visibilitySubject:Subject<any>;
  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");   

  }

  constructor(private httpClient:HttpClient) {
    this.copyRelanceSubject=new Subject();
    this.deadlineSubject=new Subject();
    this.visibilitySubject=new Subject();
   }

  activeOrDesactiveReviveMailCopy(status:any){
    const requestCopyRevive = {
      "parameter": status
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.reviveMailPath,requestCopyRevive,{headers: header}).subscribe((response: any) => {
      this.copyRelanceSubject.next(response);
      this.copyRelanceSubject.complete();
  },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  setVisitDeadline(value:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.deadlineSettingPath,value,{headers: header}).subscribe((response: any) => {
      this.deadlineSubject.next(response);
      if (response.code === "45859d1ba9e878f62c51935e3119d7ad") {
        localStorage.setItem("visitDeadline", value);
      }
      // this.deadlineSubject.complete();
    },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  setFieldVisibility(reqBody:any){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    this.httpClient.post(this.fieldSettingPath,reqBody,{headers: header}).subscribe((response: any) => {
      this.visibilitySubject.next(response);
      // this.deadlineSubject.complete();
    },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  getConfig(){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<any>(`${this.configPath}`, {headers: header});
  }
}
